import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Editor from "../pages/editor/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/bearbeiten",
    element: <Editor />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
